( function( $ ){
  
  var ZoomSlider = {
    
    init: function(){
      
      var __this = this;
      this.init = 0;
      this.load = 0;
      this.zWidth = 0;
      this.zHeight = 0;
      this.cursor = this.find( '.icon')
      
      this.hover( function( e ){
        
        if( ! __this.init ) {
          
          __this.init++;
          __this.setup();
          
          
        }
        
      }, function(){
      
        __this.removeClass( 'active' );
        
      } );
      
      this.mousemove( function( e ){
        
        __this.calc( e );
        
      } );
      
    }, 
    
    setup: function(){
      
      var __this = this;
      
      this.find( 'img.zoom' ).remove();
      
      this.img = $( '<img src="' + this.attr( 'data-zoom' ) + '" class="zoom"></img>' )
      this.img
        .appendTo( this )
        .on( 'load', function(){
          
          __this.complete();
          
        } );
        
      this.img[0].complete.trigger( 'load' );
    },
    complete: function(){
      
      var __this = this;
      this.load = 1;
      this.zWidth = this.width() - this.img.width();
      this.zHeight = this.height() - this.img.height();
      
    },
    calc: function( e ){
      
      var __this = this;
      
      if( ! this.load ) return;
      
      this.addClass( 'active' );
      
      posX = e.pageX - this.offset().left;
      posY = e.pageY - this.offset().top;
      
      perX = posX / this.width();
      perY = posY / this.height();
      
      offX = perX * this.zWidth;
      offY = perY * this.zHeight;
      
      this.cursor.css( 'top', posY );
      this.cursor.css( 'left', posX );
      
      this.img.css( 'transform', 'translate(' + offX + 'px, ' + offY + 'px)' );
      
    } 
    
  }
  
  var ProductTabs = {
      
    init: function(){
      
      var __this = this;
      
      this.li = this.find( 'li' );
      this.div = this.find( '.tab-content > div' );
      
      this.li.on( 'click', function( e ){
        
        e.preventDefault();
        __this.runClick( $( this ) );
        
      } )
      
      this.runClick( this.li.first() );
      
    },
    
    runClick: function( el ) {
      
      var __this = this;
      
      index = el.index();
      
      el
        .addClass( 'active' )
        .siblings()
          .removeClass( 'active' )
          
      this.div.eq( index )
        .addClass( 'active' )
        .siblings()
          .removeClass( 'active' )
          
      height = this.div.eq( index ).outerHeight();
      
      this.div.eq( index ).parent().height( height );
      
    }
    
  }
  
  var sizingTables = {
    
    init: function(){
      
      var __this = this;
      this.td = this.find( 'td' );
      this.timer = null;
      
      //this.td.each( function(){ $( this ).css( 'border', '10px solid red' ); } );
      
      this.td.hover( function(){
        
        clearTimeout( __this.timer );
        
        index = $( this ).index();
        index++;
        
        __this.find( 'td:nth-child( ' + index + ' )' )
          .addClass( 'hover' )
          .siblings()
            .removeClass( 'hover' );
        
      }, function(){
        
        __this.timer = setTimeout( function(){
          
          __this.td.each( function(){
            
            $( this ).removeClass( 'hover' );
            
          } );
          
        }, 150);
        
      } )
      
    }
    
  }
  
  var relatedCollection = {
    
    init: function(){
      
      var __this = this;
      
      this.isRunning = 0;
      
      this.handle = '';
      
      this.setupRelated();
      
      $( 'body' ).on( 'swatch', function(){
        
        __this.setupRelated();
        
      } )
      
    }, 
    
    setupRelated: function(){
      
      var __this = this;
      
      setTimeout( function(){ 
        
          if( ! __this.isRunning ) __this.runRelated(); 
          //__this.setupRelated();
          
      }, 1000 );
      
    },
    
    runRelated: function(){
      
      var __this = this;
      
      relItem = $( '#bc-sf-filter-products > div:not([related]' );
      
      if( ! relItem.length ) {
        
        this.isRunning = 0;
        return;
        
      }
      
      this.isRunning = 1;
      
      relItem.first().each( function(){
        
        $( this ).attr( 'related', 1 );
        
        var el = $ ( this );
        
        this.handle = el.find( '.first-product-url' ).attr( 'href' ); 
        
        var metaUrl = this.handle + '?view=all_related_p_test';
        
        __this.handle = this.handle.replace( '/products/', '' );
        
        var getUrl = $.ajax({
          
          url: metaUrl,
          type: 'GET',
          async: false,
          
        } )
        
        getUrl.always( function( data ){
          
          setTimeout( function(){ 
            
            el.attr( 'related-complete', 'complete' );
            __this.isRunning = 0; 
            
            __this.setupEachRelated( data, el )
            __this.runRelated(); 
             
            
          }, 50 )
          
          
        } )
        
      } )
      
    },
    
    setupEachRelated: function( data, el ){
      
      var __this = this;
      
      intSwatch = $( data ).find( '.swatch-item' )
      intForm = $( data ).find( '.form-item' );
      
      if( ! intSwatch.length ) this.formActions( el.find( 'form' ) );
      
      for( x = 0; x< intSwatch.length; x++ ){
        
        this.setupItem( intSwatch.eq(x), intForm.eq(x), el );
        
      }
      
    },
    
    setupItem: function( swatchEl, formEl, el ){
      
      var __this = this;
      
      var itemHandle = el.find( 'a' ).first().attr( 'href' ).split( '/' );
      itemHandle = itemHandle[ itemHandle.length - 1 ];
      
      var swatchHandle = swatchEl.find( 'meta' ).attr( 'data-handle' );
      
      var activeClass = itemHandle == swatchHandle ? 'is-initial active' : '';
      
      if( swatchEl.find( 'a' ).length ){
        
        var swatch = $( '<div class="realtdProd ' + activeClass + '">' + swatchEl.first().html() + '</div>' );
        
        form = formEl.find( 'form' )
        form.addClass( activeClass );
        form.appendTo( el.find( '.product-form--container' ) )
        
        swatch.data( 'form', form );
        swatch[0].offsetHeight;
        
        this.swatchActions( swatch );
        
        el.find( '.relatedP' ).append( swatch );
        
        __this.formActions( form );
        
        el.hover( function(){
            
        }, function(){
          
          $( this ).find( '.realtdProd.is-initial' ).trigger( 'click' )
          
        } )
        
      }
      
    },
    
    swatchActions: function( swatch ){
      
      var __this = this;
      
      swatch.on( 'click', function( e ){
          
        if( $( this ).is( '.is-initial' ) ) {
          
          $( this ).closest( '.card' ).find( 'img' ).removeClass( 'is-active' );
          
        } else {
        
          if( typeof ( $( this ).data( 'img' ) ) == 'undefined' ) {
            
            el = $( '<img class="is-product hover normal w-100 lazy blur-up initial" src="' + $( this ).find( 'a' ).first().attr( 'data-img' ) + '"></img>' );
            
            el.on( 'load', function(){
              $( this )
                .addClass( 'is-active' )
                .siblings()
                  .removeClass( 'is-active' );
            } )
            el.each( function(){
              if( $( this )[0].complete ){
                $( this ).trigger( 'load' ); 
              }
            } );
            
            $( this ).data( 'img', el )
            el.appendTo( $( this ).closest( '.card' ).find( '.card-img > a' ) )
            
          } else {
            
            $( this ).data( 'img' )
              .addClass( 'is-active' )
              .siblings()
                .removeClass( 'is-active' );
            
          }
        
        }
        
        $( this ).addClass( 'active' )
          .siblings().removeClass( 'active' );
          
        $( this ).data( 'form' ).addClass( 'active' )
          .siblings().removeClass( 'active' );
          
        e.preventDefault();
        
      } );
      
    },
    
    formActions: function( form ){
      
      var __this = this;
      
      form.find( 'li' ).on( 'click', function( e ){
        
        var input = $( this ).find( 'input' );
        input.prop( 'checked', 'checked' );
        input[0].offsetHeight;
        
        var form = $( this ).closest( 'form' );
        
        e.preventDefault();
        var form_data = form.serialize();
        console.log(form_data);
        var params = form_data;
        
        $.ajax ( {
          
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          async:false,
          data: params,
          success: function( response ){
            
            __this.loadCart();
            
          },
          error: function(){
            
            console.log('Error add to via ajax');
                      
          }
          
        } );
        return false;
        
      } )
      
    },
    
    loadCart: function(){
      
      var __this = this;
      
      $("body").addClass("header-minicart-open");
      $('.cart-ajax-loader').show();      
      $('#cart-container').load('/ #cart-container > div',function() {
        $('.cart-ajax-loader').hide();
        $('#cart-container').show();
        $('#cart-container').addClass('open');        
        
        // Update the item count in header
        $.ajax({
          url: '/cart.js',
          type: "GET",
          dataType: 'json',
          async:false
      }).done(function(response) {           

          var obj_cart = response;
          $('#CartCount span').text(obj_cart.item_count);
          $('.bag-cart-count span').text('BAG (' +obj_cart.item_count+')');
          
        }).fail(function(jqXHR, textStatus, errorThrown) {
          // handle the error...
          console.log("Error loading cart");
        });
      });
      
    }
    
  }
  
  var relatedCollectionBAK = {
    
    init: function(){
      
      var __this = this;
      
      this.isRunning = 0;
      
      this.handle = '';
      
      this.setupRelated();
      
    }, 
    
    setupRelated: function(){
      
      var __this = this;
      
      setTimeout( function(){ 
        
          if( ! __this.isRunning ) __this.runRelated(); 
          __this.setupRelated();
          
      }, 1000 );
      
    },
    
    runRelated: function(){
      
      var __this = this;
      
      relItem = $( '#bc-sf-filter-products > div:not([related]' );
      
      if( ! relItem.length ) return
      
      this.isRunning = 1;
      
      relItem.first().each( function(){
        
        $( this ).attr( 'related', 1 );
        
        var el = $ ( this );
        
        this.handle = el.find( '.first-product-url' ).attr( 'href' ); 
        
        var metaUrl = this.handle + '?view=all_related_p';
        
        __this.handle = this.handle.replace( '/products/', '' );
        
        var getUrl = $.ajax({
          
          url: metaUrl,
          type: 'GET',
          async: false,
          
        } )
        
        getUrl.always( function( data ){
          
          el.append( data );
          
          if( $( '#bc-sf-filter-products > div:not([related]' ).length ) setTimeout( function() {__this.runRelated(); }, 150 );
          else {
            
            __this.isRunning = 0; 
            __this.runEachRelated( data, el );
            
          }
          
        } )
        
      } )
      
    },
    
    runEachRelated: function(  ){
      
      var __this = this;
      
      el = $( '#bc-sf-filter-products > div[related]:not([related-complete])' ).first();
      
      if( ! el.length ) return
      
      if( ! el.find( 'meta[data-url]' ).length ){
        
        el
          .attr( 'related-empty', 1 )
          .attr( 'related-complete', 1 )
          
        __this.runEachRelated();
        
        return;
        
      }
      
      var promises = [];
      
      el.find( 'meta[data-url]' ).first().each( function( index, item ) {    
        
        var swatchUrl = $( this ).attr( 'data-url' );
        //var itemLocal = localStorage.getItem( swatchUrl.split( '/products/' )[1].split( '?' )[0] );
        
        $( this ).remove();
        
        if( /* itemLocal != null && */ 1 == 2 ) { // has a local version
          
          el.find( '.relatedP' ).append( '<div class="realtdProd">' + $( itemLocal ).find( '> div' ).html() + '</div>' );
          
          if( ! el.find( 'meta[data-url]' ).length ) el.attr( 'related-complete', 1 )
          __this.runEachRelated();
          
        } else { // no local version
        
          var p = $.ajax( {
            url: swatchUrl,
            type: 'GET',
            async: false,
          } );
          
          p
            .then( function( itemData ) {
              __this.setupItem( itemData, el )
            }, function(){
              
              if( ! el.find( 'meta[data-url]' ).length ) {
                
                __this.formActions( el.find( 'form' ).first() )
                el.attr( 'related-complete', 1 );
                
              }
              setTimeout( function(){ __this.runEachRelated(); }, 150 )
              
            } );
          
            //promises.push(p);
            
          }
        
      });
      
    }, 
    
    setupItem: function( itemData, el ){
      
      var __this = this;
      
      var myData = $.trim ( itemData );
      
      var itemHandle = el.find( 'a' ).first().attr( 'href' ).split( '/' );
      itemHandle = itemHandle[ itemHandle.length - 1 ];
      
      var swatchHandle = $( itemData ).find( 'meta' ).attr( 'data-handle' );
      
      // localStorage.setItem( swatchHandle, myData );
      
      var activeClass = itemHandle == swatchHandle ? 'is-initial active' : '';
      
      if( $( myData ).find( '.the-swatch a' ).length ){
        
        var swatch = $( '<div class="realtdProd ' + activeClass + '">' + $( itemData ).find( '.the-swatch' ).first().html() + '</div>' );
        
        myForm = $( itemData ).find( 'form' )
        myForm.addClass( activeClass );
        myForm.appendTo( el.find( '.product-form--container' ) )
        
        swatch.data( 'form', myForm );
        swatch[0].offsetHeight;
        
        this.swatchActions( swatch );
        
        el.find( '.relatedP' ).append( swatch );
        
        __this.formActions( myForm );
        
        if( ! el.find( 'meta[data-url]' ).length ){ 
          
          el.attr( 'related-complete', 1 );
          el.hover( function(){
            
          }, function(){
            
            $( this ).find( '.realtdProd.is-initial' ).trigger( 'click' )
            
          } )
          
        }
        
        setTimeout( function(){ __this.runEachRelated(); }, 150 );
        
      }
      
    },
    
    swatchActions: function( swatch ){
      
      var __this = this;
      
      swatch.on( 'click', function( e ){
          
        if( $( this ).is( '.is-initial' ) ) {
          
          $( this ).closest( '.card' ).find( 'img' ).removeClass( 'is-active' );
          
        } else {
        
          if( typeof ( $( this ).data( 'img' ) ) == 'undefined' ) {
            
            el = $( '<img class="is-product hover normal w-100 lazy blur-up initial" src="' + $( this ).find( 'a' ).first().attr( 'data-img' ) + '"></img>' );
            
            el.on( 'load', function(){
              $( this )
                .addClass( 'is-active' )
                .siblings()
                  .removeClass( 'is-active' );
            } )
            el.each( function(){
              if( $( this )[0].complete ){
                $( this ).trigger( 'load' ); 
              }
            } );
            
            $( this ).data( 'img', el )
            el.appendTo( $( this ).closest( '.card' ).find( '.card-img > a' ) )
            
          } else {
            
            $( this ).data( 'img' )
              .addClass( 'is-active' )
              .siblings()
                .removeClass( 'is-active' );
            
          }
        
        }
        
        $( this ).addClass( 'active' )
          .siblings().removeClass( 'active' );
          
        $( this ).data( 'form' ).addClass( 'active' )
          .siblings().removeClass( 'active' );
          
        e.preventDefault();
        
      } );
      
    },
    
    formActions: function( form ){
      
      var __this = this;
      
      form.find( 'li' ).on( 'click', function( e ){
        
        var input = $( this ).find( 'input' );
        input.prop( 'checked', 'checked' );
        input[0].offsetHeight;
        
        var form = $( this ).closest( 'form' );
        
        e.preventDefault();
        var form_data = form.serialize();
        console.log(form_data);
        var params = form_data;
        
        $.ajax ( {
          
          type: 'POST',
          url: '/cart/add.js',
          dataType: 'json',
          async:false,
          data: params,
          success: function( response ){
            
            __this.loadCart();
            
          },
          error: function(){
            
            console.log('Error add to via ajax');
                      
          }
          
        } );
        return false;
        
      } )
      
    },
    
    loadCart: function(){
      
      var __this = this;
      
      $("body").addClass("header-minicart-open");
      $('.cart-ajax-loader').show();      
      $('#cart-container').load('/ #cart-container > div',function() {
        $('.cart-ajax-loader').hide();
        $('#cart-container').show();
        $('#cart-container').addClass('open');        
        
        // Update the item count in header
        $.ajax({
          url: '/cart.js',
          type: "GET",
          dataType: 'json',
          async:false
      }).done(function(response) {           

          var obj_cart = response;
          $('#CartCount span').text(obj_cart.item_count);
          $('.bag-cart-count span').text('BAG (' +obj_cart.item_count+')');
          
        }).fail(function(jqXHR, textStatus, errorThrown) {
          // handle the error...
          console.log("Error loading cart");
        });
      });
      
    }
    
  }
  
  var ProductImages = {
    
    init: function(){
      
      var __this = this;
      
      this.isInit = 0;
      
      this.slider = $( '.mobile-slider' );
      this.sliderContainer = this.slider.find( '.mobile-slider--container' );
      this.desk = $( '.full-img-slider' );
      this.prev = this.slider.find( '[href="#prev"]' );
      this.next = this.slider.find( '[href="#next"]' );
      
      this.slickPrev = null;
      this.slickNext = null;
      
      $( window ).resize( function(){
        
        __this.checkMobile();
        __this.checkSizing();
        
      } )
      
      this.slider.find( 'img' ).each( function(){
        
        $( this ).on( 'load', function(){
          
          __this.checkSizing();
          
        } );
        
      } )
      
      this.checkMobile();
      this.checkSizing();
      
    },
    
    checkMobile: function(){
      
      var __this = this;
      
      if( ! this.isInit && this.slider.is( ':visible' ) ){
        
        this.isInit = 1;
        this.runSetup();
        
      } 
      
    }, 
    
    checkSizing: function(){
      
      var __this = this;
      
      el = this.slider.find( '.slick-slide[data-slick-index="0"]' ).first();
      
      var height = el.find( '> div' ).first().height();
      
      el.siblings().height( height );
      
    },
    
    runSetup: function(){
      
      var __this = this;
      
      this.desk.find( 'img' ).each( function(){
        
        $( '<div><img src="' + $( this ).attr( 'src' ) + '" ></img></div>' )
          .appendTo( __this.sliderContainer )
        
      } )
      
      this.sliderContainer.slick( {
        
				infinite: true,
				autoplay: false,
				autoplaySpeed: 3000,
				slidesToShow:1,
				arrows: true,
				slidesToScroll:1,
				dots: true,
        mobileFirst: true
        
			} );	
			
			this.slickPrev = this.slider.find( '.slick-prev' )
			this.slickNext = this.slider.find( '.slick-next' )
			
			this.prev.on( 'click', function(e) {
  			
  			__this.slickPrev.trigger( 'click' );
  			e.preventDefault();
  			
			} );
			
			this.next.on( 'click', function(e) {
  			
  			__this.slickNext.trigger( 'click' );
  			e.preventDefault();
  			
			} );
      
    }
    
  }
  
  var Announce = { 
		
		init: function(){
			
			var __this = this;
			
			this.el = $( this ).find( '> *' );
			
			this.curr = 0;
			
			$( window ).on( 
				
				'resize', function(){
					
					__this.runHeight();	
					
				}
				
			).trigger( 'resize' );
			
			this.runBlock();
			
		}, 
		
		runHeight: function(){
			
			intHeight = 0;
			
			this.el.each( function(){
				
				checkHeight = $( this ).outerHeight();
				
				if( checkHeight > intHeight ) intHeight = checkHeight;
				
			} )
			
			this.height( intHeight );
			
		}, 
		
		runBlock: function(){
			
			var __this = this;
			
			this.el.eq( this.curr )
				
				.addClass( 'active' )
				.siblings()
					.removeClass( 'active' );
					
			this.curr++;
			
			this.curr = this.curr % this.el.length;
			
			setTimeout( function(){ __this.runBlock(); }, 6000 );
			
		}
		
	}
	
	var PageHeight = {
  	
  	init: function(){
    	
    	var __this = this;
    	
    	$( window ).on( 'resize', function(){
      	
      	__this.minHeight();
      	
    	} )
    	$( window ).on( 'load', function(){
      	
      	console.log( 'loaded' );
      	__this.minHeight();
      	
    	} );
  	},
  	
  	minHeight: function(){
    	
    	var minH = $( window ).height() - $( 'main' ).offset().top - $( '#shopify-section-footer' ).outerHeight();
    	$( 'main' ).css( 'min-height', minH );
    	
  	}
  	
	}
  
  $( window ).on( 'load', function(){
    
    $( 'body.template-collection' ).each( function(){
    
      var coll = $( 'body.template-collection' );
      
      if( typeof coll.data( 'related' ) == 'undefined' ) {
        
        coll.data( 'related', relatedCollection); 
        coll.data( 'related' ).init();
        
      } 
      
    } );
    
  } );
  
  $( document ).on( 'ready', function(){
    
    PageHeight.init();
    
    $( '.announce--container' ).each( function(){ 
			
  		el = $( this );
  		$.extend( el, Announce ); 
  		el.init();
  		
  	} )
    
    $( 'body.template-product' ).each( function(){
      
      $( this ).data( 'product-images', ProductImages );
      $( this ).data( 'product-images' ).init();
      
    } )
    
    $( 'body.template-collection' ).each( function(){
      
      $( this ).data( 'related', relatedCollection); 
      $( this ).data( 'related' ).init();
      
    } )
    
    $( 'body.template-index [id*="filter-products"]' ).each( function() {
      
      //$( this ).data( 'related', relatedCollection); 
      //$( this ).data( 'related' ).init();
      
    } );
    
    $( '.sizing-tabs table' ).each( function(){
      
      //$( this ).data( 'sizing', sizingTables );
      //$( this ).data( 'sizing' ).init();
      
      el = $( this );
      $.extend( el, sizingTables );
      el.init();
      
    } ); 
      
    $( '.full-img-slider .slider-big-image' ).each( function(){
  
      el = $( this );
      $.extend( el, ZoomSlider );
      el.init();
      
    } );
    
    $( '.new-wear-tabs, .sizing-tabs' ).each( function(){
      
      el = $( this );
      $.extend( el, ProductTabs );
      el.init();
      
    } )
    
  } ) 

  
   $(window).on('load', function () {
   
    $( '.announce--container' ).each( function(){ 
			
  		el = $( this );
  		$.extend( el, Announce ); 
  		el.init();
  		
  	} )
   })
  
  Filter = {
    
    init: function(){
      
      var __this = this;
      
      el = $( '.bc-sf-filter-option-block-collection' ).first();
      
      $( window ).on( 'resize', function(){
        
        // __this.checkMobile():  
        
      } )
      
      //this.checkMobile();
      
    },
    
    checkMobile: function(){
      
      var __this = this;
      if( ! $( 'body' ).is( '[data-filter]' ) && $( window ).width() < 800 && el.find( '.bc-sf-filter-block-content' ).is( '[visible]'  ) ){
        
        el.find( '.bc-sf-filter-block-title' ).trigger( 'click' );
        
      }
      
    }
    
  }
  
  AccordionNew = {
    
    init: function(){
      
      var __this = this;
      this.item = $( this ).find( '.item' );
      this.item.on( 'click', function(){
        
        __this.setHeight( $( this ) );
        
      } );
      
      this.setHeight( this.item.first() );
      
    },
    
    setHeight: function( el ){
      
      var __this = this;
      isSet = el.is( '.active' ) ? 1 : 0;
      if( ! isSet ){
        
        el.addClass( 'active' );
        el.find( '.content' ).height( el.find( '.content > div' ).first().outerHeight() );
        
      } else {
        
       el.removeClass( 'active' )
       el.find( '.content' ).height( 0 ); 
        
      }
      
    }
    
  }
  
  Bundle = {
    
    init: function(){
      
      var __this = this;
      
      this.product = this.find( '.bundle-product' );
      this.btn = this.find( '.btn:not(.btn__active)' );
      this.modalBtn = this.find( '.btn.btn__active' );
      this.modalClose = this.closest( '.bundle-container' ).find( 'a[href="#close"]' );
      
      this.product.each( function(){
        
        $( this ).data( 'item', $( this ) )
        $.extend( $( this ).data( 'item' ), BundleProduct )
        $( this ).data( 'item' ).init( __this );
        
      } )
      
      this.checkReady();
      
      this.btn.on( 'click', function( e ){
        
        __this.bundleToCart();
        e.preventDefault();
        
      } );
      
      this.modalBtn.on( 'click', function( e ){
        
        $( 'body' ).attr( 'modal-active', '1' );
        $( this ).closest( '.bundle-container' )
          .addClass( 'modal__active' )
          .find( '.bundle-content' ).scrollTop( 0 );
          
        e.preventDefault();
        
      } );
      
      this.modalClose.on( 'click', function( e ){
        
        __this.closeModal();
        e.preventDefault();
        
      } );
      
    }, 
    
    closeModal: function(){
      
      $( 'body' ).removeAttr( 'modal-active' );
      $( this ).closest( '.bundle-container' ).removeClass( 'modal__active' );
      
    },
    
    checkReady: function(){
      
      var __this = this;
      var isReady = 1;
      
      this.product.each( function(){
        
        if( ! $( this ).is( '[data-variant]' ) ){
          
          isReady = 0;
          
        }
        
      } )
      
      if( isReady ) {
        
        this.addClass( 'ready' );
        
      } else this.removeClass( 'ready' );
      
    },
    
    bundleToCart: function(){
      
      var __this = this;
      
      var el = this.find( '.bundle-product:not([data-complete])' );
      
      if( el.length ){
        
        var variant = parseInt( el.attr( 'data-variant' ) )
        
        data = {
          "id":variant,
          "quantity":1
        }
        $.ajax( {
          type: 'POST',
          url: '/cart/add.js',
          data: data,
          dataType: 'json'
        } ).done( function( response ){
          
          el = __this.find( '.bundle-product:not([data-complete])' ).first();
          el.attr( 'data-complete', 1 );
          __this.bundleToCart( );
          
        } );
        
      } else {
        
        this.product.removeAttr( 'data-complete' );
        this.closeModal();
        this.loadCart();
        
      }
      
    },
    loadCart: function(){
      
      var __this = this;
      
      $( "body" ).addClass( "header-minicart-open" );
      $( '.cart-ajax-loader' ).show();      
      $( '#cart-container' ).load( '/ #cart-container > div', function() {
        $('.cart-ajax-loader').hide();
        $('#cart-container').show();
        $('#cart-container').addClass('open');        
        
        // Update the item count in header
        $.ajax( {
          url: '/cart.js',
          type: "GET",
          dataType: 'json',
          async:false
      }).done(function(response) {           

          var obj_cart = response;
          $('#CartCount span').text(obj_cart.item_count);
          $('.bag-cart-count span').text('BAG (' +obj_cart.item_count+')');
          
        }).fail(function(jqXHR, textStatus, errorThrown) {
          // handle the error...
          console.log("Error loading cart");
        });
      });
      
    }
    
  }
  
  BundleProduct = {
    
    init: function( root ){
      
      var __this = this;
      this.root = root;
      this.item = this.find( '.bundle-item' );
      this.details = this.find( '.product-details' );
      this.isModal = this.find( '.bundle-carousel__mobile' ).length;
      
      this.isActive = 0;
      
      this.color = '';
      this.size = '';
      
      this.setupSwatches();

      this.btn = this.find( '.product-size-list li' );
      this.btn.on( 'click', function(){
        
        __this.runClick( $( this ) );
        
      } );
      
      this.hover( function(){
        
        clearTimeout( __this.timer );
        
        __this.find( '.item-swatch.active' ).each( function(){
          
          $( this ).data( 'img' ).addClass( 'active' )
            .siblings().removeClass( 'active' );
                      
        } );
        
      }, function(){
        
        if( ! __this.isActive ) {
          
          __this.timer = setTimeout( function(){ __this.runCarousel(); }, 3000 );
          
        } else {
          
          __this.find( '.product-img.is-initial' )
            .addClass( 'active' )
            .siblings()
              .removeClass( 'active' );
          
        }
        
      } );
      
      this.runCarousel();
      
    }, 
    
    runCarousel: function(){
      
      var __this = this;
      
      if( this.isActive || this.isModal ) return;
      
      var active = this.find( '.product-image.active' );
      var img = this.find( '.product-image' );
      
      if ( ! active.length ) {
        img.first().addClass( 'active' );
        this.timer = setTimeout( function(){ __this.runCarousel(); }, 3000 );
        return;        
      }
      
      var next = active.next();
      
      if(! next.length ) {
        img.first().addClass( 'active' )
          .siblings()
            .removeClass( 'active' );
        
        this.timer = setTimeout( function(){ __this.runCarousel(); }, 3000 );
        return;        
      }
      
      next.addClass( 'active' )
        .siblings()
          .removeClass( 'active' );
      
      this.timer = setTimeout( function(){ __this.runCarousel(); }, 3000 );
      
      
    },
    
    setupSwatches: function(){
      
      var __this = this;
      
      this.item.each( function(){
        
        __this.setupSwatch( $( this ) );
        
      } );
      
    },
    
    setupSwatch: function( el ){
      
      var __this = this;
      
      swatch = el.find( '.item-swatch' );
      swatchBlock = this.find( '.bundle-swatch' );
      
      img = el.find( '.product-image' );
      swatchCarousel = this.find( '.bundle-carousel' );
      
      el.data( 'img', img );
      
      swatch.data( 'item', el );
      swatch.data( 'img', img );
      
      swatch.appendTo( swatchBlock );
      img.appendTo( swatchCarousel );
      
      swatch.on( 'click', function(){
        
        __this.runSwatch( $( this ) );
        
      } );
      
      if( ! swatch.index() ) this.runSwatch( swatch );
      
    },
    
    runSwatch: function( el ){
      
      var __this = this;
      
      this.color = $.trim( el.text() );
      
      el.addClass( 'active' )
        .siblings()
          .removeClass( 'active' );
      
      el.data( 'item' ).addClass( 'active' )
        .siblings()
          .removeClass( 'active' );
          
      el.data( 'img' ).addClass( 'active' )
        .siblings()
          .removeClass( 'active' );
          
      this.removeAttr( 'data-variant' );
      this.root.checkReady();
      this.details.text( 'Select Color and Size' );
      this.find( '.product-size-list' ).removeClass( 'active' );
      this.isActive = 0;
      
    },
    
    setupCarousel: function( el ){
      
      
      
    },
    
    runClick: function( el ){
      
      var __this = this;
      
      this.isActive = 1;
      
      val = el.find( 'input' ).attr( 'value' );
      
      this.attr( 'data-variant', val );
      
      el.addClass( 'active' )
        .siblings()
          .removeClass( 'active' );
          
      item = this.returnEl( el );
      item
        .siblings()
          .find( '.product-size-list li' ).removeClass( 'active' );
          
      this.swatch = el.text();
      
      this.details.text( this.color + ' / ' + this.swatch );
      
      img = el.closest( '.bundle-item' ).data( 'img' );
      img.addClass( 'is-initial' )
        .siblings()
          .removeClass( 'is-initial' );
          
      this.root.checkReady();
      
    },
    
    returnEl: function( el ){
      
      return el.closest( '.bundle-item' );
      
    } 
    
  }
  
} )(jQuery);

jQuery(document).ready(function($) {
  
  $( '.bundle' ).each( function(){
    
    $( this ).data( 'bundle', $( this ) );
    $.extend( $( this ).data( 'bundle' ), Bundle );
    $( this ).data( 'bundle' ).init();
    
  } )
  
  $( 'body.template-collection' ).each( function(){
    
    Filter.init();
    
  } );
  
  $( '.accordion-new' ).each( function(){
    
    $( this ).data( 'acc', $( this ) );
    $.extend( $( this ).data( 'acc' ), AccordionNew );
    $( this ).data( 'acc' ).init();
    
  } );
  
  $( 'body' ).on( 'click', '.card-img-hover label', function( e ){
    
    e.preventDefault();
    el = $( e.target );
    div = el.closest( '.card-img-hover' ).find( '.product-form--container' );
    if ( div.is( '.active' ) ) {
      div.removeClass( 'active' );
      div.height( 0 );
    } else {
      div.addClass( 'active' );
      div.height( div.find( '> *:visible' ).first().height() )
    }
    
  } )
  
  $( 'body' ).on( 'click', function(e){
    
    el = $( e.target );
    
    if( el.is( '[href="#filter-by"]' ) || el.closest( '[href="#filter-by"]' ).length ) {
      
      e.preventDefault()
      
      if( $( 'body' ).is( '[data-filter]' ) ){
        $( 'body' ).removeAttr( 'data-filter' )  
      } else {
        $( 'body' ).attr( 'data-filter', 1 );
      }
      
    } else {
      
      if( $( 'body' ).is( '[data-filter]' ) ){
        
        if( ! el.closest( '.top-sorting--container' ).length ){
          
          $( 'body' ).removeAttr( 'data-filter' )   
          
        }
      }
      
    }
    
    if( el.is( '[href="#sort-by"]' ) || el.closest( '[href="#sort-by"]' ).length ) {
      
      e.preventDefault()
      
      if( $( 'body' ).is( '[data-sort]' ) ){
        $( 'body' ).removeAttr( 'data-sort' )  
      } else {
        $( 'body' ).attr( 'data-sort', 1 );
      }
      
    } else {
      
      if( $( 'body' ).is( '[data-sort]' ) ){
        
        if( ! el.closest( '#bc-sf-filter-top-sorting' ).length ){
          
          $( 'body' ).removeAttr( 'data-sort' )   
          
        }
      }
      
    }
    
    
  } )
  
  $( '#bc-sf-filter-tree-mobile-button-new' ).on( 'click', function(){
    
    $( '.refine-container' ).toggleClass( 'open' );
    
  } );
  /* 
  $( '[href="#sort-by"]' ).on( 'click', function( e ){
    
    e.preventDefault()
    
    if( $( 'body' ).is( '[data-sort]' ) ){
      $( 'body' ).removeAttr( 'data-sort' )  
    } else {
      $( 'body' ).attr( 'data-sort', 1 );
    }
    
  } );
  
  $( '[href="#filter-by"]' ).on( 'click', function( e ){
    
    e.preventDefault();
    
    if( $( 'body' ).is( '[data-filter]' ) ){
      $( 'body' ).removeAttr( 'data-filter' )  
    } else {
      $( 'body' ).attr( 'data-filter', 1 );
    }
    
  } );
  */
  
//   var heightHeader = $('.header-height').height();
//   console.log(heightHeader+'123');
//    $("body").css("padding-top", heightHeader+"px");
  
  var bodyheight = $(window).height();
  var height = $(window).height()- parseInt(200);
  var sidebarHeight = $('.sticky-top.custom-height-mod').height();

var d = $(document).scrollTop();
//   $('.bc-sf-filter-option-block .bc-sf-filter-block-title h3 span').click(function(){
    
//   	if(sidebarHeight > height){
      
//       $('.sticky-top.custom-height-mod').css('position:', 'static');
//       console.log('123456')
      
//     }
//   })
  $(window).scroll(function() {  
    var sidebarHeight = $('.sticky-top.custom-height-mod').height();
    if(sidebarHeight > height){

      $('#bc-sf-filter-wrapper .left-sidebar .sticky-top.custom-height-mod').css("position", "static");
      //css('position:', 'static');
    }else{
      $('#bc-sf-filter-wrapper .left-sidebar .sticky-top.custom-height-mod').css("position", "sticky");
    }
  })
  //   $('.annoucement-bar-cust div span.close-annoucement').click(function(){
      $(window).on('load',function(){
        var cookieValue_bar = $.cookie("annoucement_bar");
        if( cookieValue_bar == undefined || cookieValue_bar != 'no' ) {
//             setTimeout(function () {
                $('.annoucement-bar-cust').addClass('d-md-block');
//             }, 500);
        }else{
      $('body').addClass('annoucement-close');  	
        }
    });
    $('body').on('click','.close-annoucement',function(){
      $('.annoucement-bar-cust').addClass('d-none');
      $('body').addClass('annoucement-close-remove');
      $('body').addClass('annoucement-close');
   		$.cookie("annoucement_bar", 'no', { expires : 10 });
    });
//   $('.custom-toggle-cust').hide();
  function productSlider() {	
		if(!$(".product-images-slider").hasClass('slick-initialized')){
			if(!$(".product-images-slider").hasClass('slick-initialized')){
				$(".product-images-slider").slick({
					infinite: true,
					autoplay: false,
					autoplaySpeed: 3000,
					slidesToShow:1,
					arrows: true,
					slidesToScroll:1,
					dots: false,
                  	mobileFirst: true
				});	
			}
		}
    }
  /*listing img hover slider*/
  productSlider();
//     $("body").on("mouseover", "a.first-product-url", function(e){
//       $(this).parent().addClass("slider-open");		
//     });
  
	$('body').on('click', '.action-links .search', function(event) {
		$('.action-links').hide();
		$('.search-wrap').show();
	});
	$(window).on('load',function(){
		var cookieValue = $.cookie("show_popup");
		if( cookieValue == undefined || cookieValue != 'no' ) {
			setTimeout(function () {
				$('.custom-popup-form').modal('show');
			}, 5000);
		}
		$.cookie("show_popup", 'no', { expires : 10 });
	});
	$('body').on('touchstart, click', '.has-dropdown, .mega-menu', function(event) {
		$(this).toggleClass('open');
	});
// 	$('body').on('click', '.has-dropdown, .mega-menu', function(event) {
// 		$(this).toggleClass('open');
// 	});
	$('body').on('click', '.menu-toggle', function(event) {
		$(this).toggleClass('open');
		$('.nav-menu').toggleClass('d-flex');
	});			
// 	$(document).click(function(e) {
// 		if (!$(e.target).is('.search-btn *')) {
// 			$('.search-top').removeClass('open');
// 		}
// 	});
// 	$('body').on('click', '.search-btn', function(event) {
// 		$('.search-top').addClass('open');
// 	});
	$('body').on('click', '.search-form', function(event) {
		$('.search-top').addClass('open');
	});
  
    $('body').on( 'click', '#bc-sf-filter-tree-mobile-button', function( ){
      
      /*
      var This = $(this);
      setTimeout(function(){
        if(This.parent().hasClass('open')) {
          $('.cust-filter-sort-by').show();
          $('.cust-sort-by-title').show();
        } else {
          $('.cust-filter-sort-by').hide();
          $('.cust-sort-by-title').hide();
        }
      },500);
      */
    });
	
    
//   $('body').click(function(event) {
//     if(!$(event.target).parent().parent().is('body .search-btn')
//        && !$(event.target).parent().parent().parent().is('body .search-top')
//        && !$(event.target).parent().parent().is('body .search-button')) {
//       $('body .search-top').removeClass('open');
//     }
//   });
	$('body').on('click', '.cart-box', function(event) {
		$('.cart-popup').addClass('open');
	});
	$('body').on('click', '.add-bag', function(event) {
		$('.cart-popup').addClass('open');
	});
  
  
	$('body').on('click', '.cart-close', function(event) {
		$('.cart-popup').removeClass('open');
	});
  	$('body').on('click', '.close-btn', function(event) {
		$('.search-top').removeClass('open');
	});
  


	/* Banner */
	$('.home-banner .carousel-images').slick({
		dots: true,
		infinite: true,
		arrows:false,
		speed: 1000,
		autoplay: true,
		autoplaySpeed: 3000,
		slidesToShow: 1,
		slidesToScroll: 1,
      	focusOnSelect: true,
  		pauseOnHover:true
	});

	/* Our Favourites */
	$(window).resize(function() {
      	console.log('resize called');
		product_slider_front();
	});
	product_slider_front();
	function  product_slider_front(){
//       if($(window).width() >= 768) {
        if(!$(".product-slider-front").hasClass('slick-initialized')) {
          $(".product-slider-front").slick({
            infinite: true,
            autoplay: true,
            autoplaySpeed: 5000,
            slidesToShow:3,
            arrows: true,
            slidesToScroll:1,
            dots: false,
            infinite: true,
            speed: 300,
            centerMode: true,
            //variableWidth: true,
            appendArrows: $(".slider-nav"),
            prevArrow: '<button class="newswrapper_prev"><<</button>',
            nextArrow: '<button class="newswrapper_next">>></button>',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 3,
                  slidesToScroll: 1,
                  infinite: true
                }
              },
              {
                breakpoint: 767,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1,
                  infinite: true
                }
              }
            ]
          });
        }
      /*} else {
        if($(".product-slider-front").hasClass('slick-initialized')) {
        	$(".product-slider-front").slick('unslick');
        }
      }	*/
	}
	/* shop content*/
	// function mobileOnlySlider() {
	// 	$('.big-img .full-img-slider').slick({
	// 		slidesToShow: 1,
	// 		slidesToScroll: 1,
	// 		arrows:false,
	// 		dots:false,
	// 		fade: true,
	// 		autoplay: true,
	// 		infinite: true,
	// 		autoplaySpeed: 3000,
	// 		draggable: false,
	// 		asNavFor: '.small-img .small1-img-slider',
	// 		responsive: [
	// 		{
	// 			breakpoint: 992,
	// 			settings: {
	// 				arrows: false,
	// 				dots:false,
	// 			}
	// 		}
	// 		]
	// 	});
	// }
	// if(window.innerWidth >= 768) {
	// 	mobileOnlySlider();
	// }
	// $(window).resize(function(e){
	// 	if(window.innerWidth >= 768) {
	// 		if(!$('.full-img-slider').hasClass('slick-initialized')){
	// 			mobileOnlySlider();
	// 		}
	// 	}else{
	// 		if($('.full-img-slider').hasClass('slick-initialized')){
	// 			$('.full-img-slider').slick('unslick');
	// 		}
	// 	}
	// });

	// $('.small-img .small1-img-slider').slick({
	// 	slidesToShow: 4,
	// 	slidesToScroll: 1,
	// 	asNavFor: '.big-img .full-img-slider',
	// 	dots: false,
	// 	arrows: false,
	// 	vertical: true,
	// 	focusOnSelect: true,
	// 	infinite: true,
	// 	autoplay:true,
	// 	autoplaySpeed: 3000,
	// });
	$('.product-slider-front').on('breakpoint', function(event, slick, direction){
// 		console.log("=====breakpoint=====");
});
	$('body').on('click', '.left-sidebar h2', function(event) {
		$(this).next('ul').toggleClass('d-block');
	});
	jQuery('img.svg').each(function(){
		var $img = jQuery(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');
		jQuery.get(imgURL, function(data) {
	// Get the SVG tag, ignore the rest
	var $svg = jQuery(data).find('svg');
	            // Add replaced image's ID to the new SVG
	            if(typeof imgID !== 'undefined') {
	            	$svg = $svg.attr('id', imgID);
	            }
	            // Add replaced image's classes to the new SVG
	            if(typeof imgClass !== 'undefined') {
	            	$svg = $svg.attr('class', imgClass+' replaced-svg');
	            }

	            // Remove any invalid XML tags as per http://validator.w3.org
	            $svg = $svg.removeAttr('xmlns:a');

	            // Check if the viewport is set, else we gonna set it if we can.
	            if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	            	$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	            }

	            // Replace image with new SVG
	            $img.replaceWith($svg);

	        }, 'xml');
	});
	$('.page-scroll').on('click', function(event) {
		var $anchor = $(this);
		$('html, body').stop().animate({
			scrollTop: $($anchor.attr('href')).offset().top
		}, 1000, 'easeInOutExpo');
		event.preventDefault();
	});
	$('body').on('click', '#exampleCheck1', function(event) {
		$('.cart-note').toggle();		
		$('.CartSpecialInstructions').toggle();		
	});
	$('.four').addClass('active');
	$('body').on('click', '.two', function(event) {
		$('.row .col-sm-6').removeClass('col-lg-3');
		$('.row .col-sm-6').addClass('col-lg-6');
        $(this).addClass('active');
        $('.four').removeClass('active');
      	$(window).trigger('resize');
        $(window).trigger('orientationchange');
      	$('.product-images-slider').slick('resize');
	});
	$('body').on('click', '.four', function(event) {
		$('.row .col-sm-6').removeClass('col-lg-6');
		$('.row .col-sm-6').addClass('col-lg-3');
        $(this).addClass('active');
        $('.two').removeClass('active');
      	$(window).trigger('resize');
      	$(window).trigger('orientationchange');
      	$('.product-images-slider').slick('resize');
	});
	$('body').on('click', '.model', function(event) {
		if($('.type-image').hasClass('active')){
			$('.type-image').removeClass('active');
			$(this).parent().addClass('active');
		}
		$('.product-image').hide();
		$('.model-image').show();
      
        $(window).trigger('resize'); 
        var myLazyLoad = new LazyLoad({
          elements_selector: ".lazy"
        });
      
	});
	$('body').on('click', '.product', function(event) {
		if($('.type-image').hasClass('active')){
			$('.type-image').removeClass('active');
			$(this).parent().addClass('active');
		}
		$('.model-image').hide();
		$('.product-image').show();
	});
	$('body').on('click', '#bc-sf-filter-tree-mobile-button', function(event) {
		$('#bc-sf-filter-tree-mobile').toggleClass('open')
		$('.left-sidebar').toggleClass('open')

	});

	$('.load-more').click(function(){
		$('.loading-styles').show();
		$('.hide-product:lt(3)').removeClass('hide-product');
		if ($('.row').hasClass('hide-product')){
			$('.load-more').show();
		}else{
			$('.load-more').hide();
		}
	});
	function custom_matchheight() {
		$('.text-height').matchHeight({
			byRow: true
		});
      
      	$('.image-box-vid .img-vid-cust').matchHeight({
			byRow: true
		});
      	$('.favorites-content').matchHeight({
        	byRow: true
      	});
      	/*
      	$('.card-img').matchHeight({
        	byRow: true
      	});
      	*/
	}
	custom_matchheight();

	function slickSlideCust() {
		if($(window).width() <= 767 ) {
			$('.you-may-likes').slick({
				dots: false,
				infinite: true,
				arrows:false,
				speed: 1000,
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToShow: 1,
				slidesToScroll: 1,
			});
		} else {
			$('.you-may-likes').slick('unslick');
		}
	}
	slickSlideCust();

	if(!$(".mobile-insta .fs-timeline").hasClass('slick-initialized')){
			//console.log("213");
		setTimeout(function(){
			$(".mobile-insta .fs-timeline").slick({
				infinite: true,
				autoplay: true,
				autoplaySpeed: 3000,
				slidesToShow:2,
				arrows: false,
				slidesToScroll:2,
				dots: false
			});	
		}, 2000);
	}
	$(window).resize(function(){
		custom_matchheight();
		slickSlideCust();
	});
    $(".mini-cart-items").mCustomScrollbar({
       autoHideScrollbar: true
    });
    /*$(".left-sidebar .sticky-top").mCustomScrollbar({
       autoHideScrollbar: true
    });*/

  
    $('#bc-sf-filter-products').bind("DOMSubtreeModified",function(){
      setTimeout(function(){
        var productCount = $('#bc-sf-filter-products .col-lg-3').length;
        $('#bc-sf-filter-scroll-to-top').html('<p>'+productCount+' items</p>');
        $('#bc-sf-filter-scroll-to-top').append('<span>Back to top</span>');
      },1000);
    });
  
    $( "body" ).on( "click", ".sort-option", function() {      
      var collection = $('#collhandle').val();
      window.location.href = '/collections/'+collection+'?sort='+$(this).val();
      //       window.history.pushState(null, null, "?sort="+$(this).val());
      //       window.history.replaceState(null, null, 'https://saltwater-sandals-au.myshopify.com/collections/all?sort='+$(this).val());
      return false;
    });
  
    /*$('.bc-sf-filter-block-title.toggle-custom h3').click(function(e){
      e.preventDefault();
      $(this).next('bc-sf-filter-block-content').slideToggle();
    });*/
  
    $( "body" ).on( "click", ".toggle-custom h3", function() {
      
      if(!$(this).parent().hasClass('open')){
        $(this).parent().addClass('open');  
        $(this).parent().siblings( ".custom-toggle" ).slideDown();
        $(this).parent().siblings( ".custom-toggle1" ).slideDown();
      }else{
        $(this).parent().removeClass('open');
        $(this).parent().siblings( ".custom-toggle" ).slideUp();
        $(this).parent().siblings( ".custom-toggle1" ).slideUp();
      }
      
  	});
//     $("input[type='radio']").click(function(){
//       var radioValue = $("input[name='id']:checked").val();
//       if(radioValue){
//         alert("123");
//         $('.add-to-cart-hover').trigger('click');
//       }
//     });
	jQuery( 'body' ).on( 'click', 'xxxx.product-size-list input', function(){
    
    console.log( 'adding to cart!' );
		var __this = $( this );
		
	  setTimeout( function(){
  	  
		  //el = __this.parent().parent().parent().next();
		  __this.closest( 'form' ).find( 'input.btn' ).trigger( 'click' );
		  //el.trigger('click');
		  
		  console.log( el.attr( 'class' ) )
		
	  }, 500 );
	
	});

	// $(".product-hover", this).addClass('99999');

    $("body").on("mouseenter", ".card", function() {
      $(this).addClass("slider-open");		
    });

  	$("body").on("mouseleave", ".card", function() {
		$(this).removeClass("slider-open");
	});
  
    $('body').on('click','.btn.swym-button',function(e){
      e.preventDefault();
    });
    
    BCSfFilter.prototype.buildAdditionalElements = function(data, eventType) {
      setTimeout(function(){
        $( ".product-images-slider" ).each(function( index ) {
          if(!$(this).hasClass('slick-initialized')){
            $(this).slick({
              infinite: true,
              autoplay: false,
              autoplaySpeed: 3000,
              slidesToShow:1,
              arrows: true,
              slidesToScroll:1,
              dots: false,
              mobileFirst: true
            });	
          }
        });
        
      },2000);
    }
    
    $('body').on('click','.bc-sf-filter-block-title',function(){
      // console.log(54654654654);
      setTimeout(function(){
        var wH = $(window).height();
        var sH = $('.custom-height-mod').height();
        // console.log(wH, sH)
        if(wH < sH) {
          if($('.custom-height-mod').hasClass('sticky-top')) {
            $('.custom-height-mod').removeClass('sticky-top');
          }
        } else {
          if(!$('.custom-height-mod').hasClass('sticky-top')) {
            $('.custom-height-mod').addClass('sticky-top');
          }
        }
      },1000);
    });

  $('body').on('click','.product-mode',function(){
    if($('.product-model ul li').first().hasClass('active')){
        $('.product-image').show();
        $('.model-image').hide();
    }else{
        $('.product-image').hide();
        $('.model-image').show();
    }
  }); 
  $(window).scroll(function () {
    if ( $(this).scrollTop() > 50 && !$('body').hasClass('shop-filter-space') ) {
      $('body').addClass('shop-filter-space');
    } else if ( $(this).scrollTop() <= 50 ) {
      $('body').removeClass('shop-filter-space');
    }
  });
});
